'use strict';

var novicell = novicell || {};


novicell.internalVideo = novicell.internalVideo || new function () {
    const internalVideoPlayButtons = document.querySelectorAll('.js-internal-play');
    this.init = function () {
        if (!internalVideoPlayButtons) return null;
        for (let index = 0, length = internalVideoPlayButtons.length; index < length; index++) {
            const playButton = internalVideoPlayButtons[index];
            const video = playButton.nextElementSibling;
            playButton.addEventListener('click', function () {
                video.load();
                playButton.classList.add('hidden');
                video.classList.remove('internal-video__video--hidden');
                video.play();
            });
        }
    };
}();
